export default {
  lang: 'German',
  homeScreen: {
    title: 'ERFÜLLEN SIE IHRE TRÄUME',
    stayConnected: 'Bleiben Sie verbunden:',
    download: 'Jetzt downloaden',
  },
  notification: {
    newAndNow: 'Neu & Aktuell!',
    alert: 'Alarm',
    message: 'Nachricht',
    contest: 'Wettbewerb',
    badge: 'Neues Abzeichen',
    'content-update': 'Inhaltsaktualisierung',
    events: 'Veranstaltungen',
  },
  loginScreen: {
    version2: {
      homeTitle:
        'Schauen wir mal, ob wir in unserem System ein Profil für Sie finden können.',
      homeTitleSub:
        'Geben Sie die E-Mail-Adresse ein, die Sie normalerweise für die Anmeldung bei Schulungsprogrammen verwenden.',
      noAccount:
        'Kein Konto gefunden ({email}), bitte versuchen Sie es mit einer anderen E-Mail oder erstellen Sie jetzt ein Konto.',
      continueButton: 'Weiter',
      success:
        'Sie haben Ihr Konto erfolgreich aktualisiert! Sie werden in Kürze auf die Startseite weitergeleitet.',
      successNewAccount:
        'Um Ihre Anmeldung abzuschließen, erhalten Sie eine Bestätigungs-E-Mail, um Ihr Konto zu verifizieren.',
      loginButton: 'Anmeldung',
      matchFound:
        'Wir haben eine Übereinstimmung gefunden. Bitte geben Sie Ihr Passwort ein, um fortzufahren.',
      magicLink: 'Melden Sie sich über einen Link in Ihrer E-Mail an:',
      magicLinkButton: 'Magic Link anfordern',
      magicLinkTitle:
        'Lassen Sie sich einen direkten Link an Ihre E-Mail schicken, mit dem Sie sich sofort anmelden können.',
      otherEmailButton: 'Einreichen',
      title:
        'Bitte nehmen Sie sich einen Moment Zeit, um alle nachstehenden Informationen auszufüllen, da dadurch Ihr persönliches Profil und Ihre Kontaktinformationen erstellt werden.',
      titleIndustry:
        'Bitte nehmen Sie sich einen Moment Zeit, um alle nachstehenden Informationen auszufüllen, da dadurch Ihr persönliches Profil und Ihre Kontaktinformationen erstellt werden.',
      register: 'Ein Konto erstellen',
      agent: 'Reiseberater',
      visitor: 'Industrie Besucher',
      step1: 'Schritt 1: Art des Nutzers',
      step2: 'Schritt 2: Ein Konto erstellen',
      step3: 'Schritt 3: Erstellen Sie Ihr Profil',
      marketingOptIn:
        'Sind Sie sicher, dass Sie nicht daran interessiert sind, mit dem Travel Trade Team dieses Programms in Verbindung zu bleiben?',
      optIn: 'Ja, ich bin interessiert',
      optOut: 'Nicht Interessiert',
      step2Sub1: 'Erzählen Sie uns von sich selbst',
      step2Sub2: 'Erzählen Sie uns von Ihrem Unternehmen',
      privacyHead: 'KOMMUNIKATIONSPRÄFERENZEN',
      privacySub:
        'Kreuzen Sie die unten stehenden Kästchen an, um sicherzustellen, dass Sie wichtige Mitteilungen vom Reisebüroteam des Anbieters (Produktaktualisierungen und -ankündigungen, Prämien, Incentives, FAMs usw.) sowie Netzwerk- und Verkaufsförderungsinitiativen von TravPRO Mobile erhalten.',
      privacy:
        'Wir schützen Ihre Privatsphäre und verkaufen, missbrauchen oder betrügen niemals Ihr Vertrauen.',
      store:
        'Laden Sie dieses Programm ganz einfach in Ihrem App-Store herunter:',
      powered: 'ANGETRIEBEN DURCH',
      toastMessage: {
        forgotSuccess:
          'Wir haben Ihnen den Link zum Zurücksetzen Ihres Passworts per E-Mail geschickt! Sie werden in 10 Sekunden zur Login-Seite weitergeleitet.',
        emailNotExisting:
          'Die von Ihnen eingegebene E-Mail-Adresse existiert nicht.',
        magicLinkMessage: 'Bitte warten Sie, wir melden Sie gerade an.',
        magicLinkError:
          'Wir konnten Ihr Konto nicht in unserer Datenbank finden. Bitte melden Sie sich manuell an. Sie werden in 10 Sekunden weitergeleitet.',
        magicLinkError1:
          'Wir konnten keinen gültigen Token finden, bitte melden Sie sich an oder fordern Sie einen neuen magischen Link an.Wenn dieses Problem weiterhin besteht, kontaktieren Sie uns bitte unter: info@travpromobile.com.',
        magicLinkError2:
          'Wir konnten Ihr Konto nicht in unserer Datenbank finden. Bitte melden Sie sich manuell an.Sie werden in 10 Sekunden weitergeleitet.',
        magicLinkSuccess:
          'Prüfen Sie Ihre E-Mail an {email}.Sie enthält einen magischen Link, mit dem du dich anmelden kannst.',
        magicLinkErrorWait:
          'Bitte warten Sie 5 Minuten zwischen den Anfragen nach magischen Links.',
        emailNotFoundError:
          'Die von Ihnen eingegebene E-Mail-Adresse kann in unseren Unterlagen nicht gefunden werden. Bitte prüfen Sie auf Schreibfehler oder erstellen Sie ein Konto.',
      },
      errors: {
        zipCodeNotFound: 'ZipCode nicht gefunden, versuchen Sie es erneut',
        zipCodeOnlyNumbers: 'ZipCode kann nur Zahlen enthalten',
        password: 'Bitte geben Sie ein Passwort ein',
        passwordNotMatching:
          'Die von Ihnen eingegebenen Passwörter stimmen nicht überein',
        passwordTooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
        emailExists:
          'Diese E-Mail Adresse existiert bereits oder ist ungültig. Bitte versuchen Sie es mit einer anderen E-Mail-Adresse oder melden Sie sich bei Ihrem Konto an.',
        fillInAllFields: 'Bitte füllen Sie alle erforderlichen Felder aus',
        fillInEmail: 'Bitte geben Sie Ihre E-Mail-Adresse an.',
        emailNotExisting:
          'Die von Ihnen eingegebene E-Mail-Adresse existiert nicht.',
      },
      fields: {
        forgotSubCopy:
          'Sie haben Ihr Passwort vergessen und möchten es ändern? ',
        forgotSubCopy2:
          'Möchten Sie das Passwort ganz umgehen? Wir schicken Ihnen eine E-Mail mit einem magischen Link, der Sie automatisch beim Programm anmeldet.',
        city: 'Stadt',
        companyName: 'Name des Unternehmens',
        role: 'Ihre Rolle',
        description:
          'Was beschreibt das Geschäft Ihres Unternehmens am besten?',
        country: 'Land',
        password: 'Passwort',
        passwordRegister: 'Passwort wählen (mindestens 8 Zeichen)',
        passwordConfirm: 'Bestätigen Sie Ihr Passwort',
        firstName: 'Vorname (gegeben)',
        lastName: 'Nachname (Familie)',
        agency: 'Name Ihrer Agentur',
        title: 'Ihre Rolle (Wählen Sie eine aus)',
        company: 'Name des Unternehmens',
        select: 'Wählen Sie unten eine Option',
        state: 'Staat',
        province: 'Bundesland/Region/Staat',
        zipCode: 'Postleitzahl',
        postalCode: 'Postleitzahl',
        affiliate: 'Welcher Gruppe gehören Sie in erster Linie an?',
        hostAgency: 'Ihre Aufnahmeagentur?',
        executive: 'Exekutive',
        management: 'Verwaltung',
        marketing: 'Marketing',
        sales: 'Vertrieb',
        coordinator: 'Koordinator',
        opt: 'Bleiben Sie mit dem Team dieses Programms in Verbindung und erhalten Sie aktuelle Informationen.',
        optMarketing:
          'Bleiben Sie mit TravPRO in Verbindung, wenn es um ähnliche Programme und Veranstaltungen geht.',
        retail: 'Einzelhandelsgeschäft Front',
        home: 'Home-Based Agent',
        independent: 'Unabhängiger Auftragnehmer',
        host: 'Gastgeber-Agentur',
        call: 'Call Center oder Web-basierte Agentur',
        other: 'Andere',
        describes:
          'Was beschreibt Sie und die Tätigkeit Ihrer Agentur am besten?',
      },
    },
    title: 'Professionelles Schulungs- und Vertriebs-Programm für Reiseberater',
    welcome: {
      headerTop: 'Willkommen zur',
      headerBottom: 'Visit California STAR-Verkaufshilfe',
    },
    sellingPoints: [
      'Das Verkaufstool Nr. 1 für den Reiseberater',
      'Tägliche Sales-Conversion-Resource',
      'High-Impact Entdeckung & Präsentationen',
      'Personalisieren mit "Favoriten"-Ordner',
      'Online, Offline - Immer, Überall',
    ],
    emailPrompt:
      'Bitte geben Sie Ihre E-Mail-Adresse ein, um zu bestätigen, dass Sie ein Reiseberater sind.',
    tAndC: {
      agree: 'Indem Sie fortfahren, stimmen Sie unserem ',
      privacyPolicy: 'Datenschutz-Bestimmungen',
      and: ' und ',
      termsConditions: 'Geschäftsbedingungen zu.',
    },
    fields: {
      agency: 'Agentur',
      email: 'E-Mail',
      firstName: 'Vorname',
      lastName: 'Nachname',
      agencyName: 'Name der Agentur',
      stateProvince: 'Staat/Provinz',
      registrationCode: 'Werbe-Code (wahlweise)',
      required: 'Notwendig',
      invalidEmail: 'Ungültige E-Mail-Adresse',
      opt: 'In Kontakt bleiben! Ja, ich möchte mich für Mitteilungen von Visit California anmelden, die mich über Neuigkeiten, Veranstaltungen, Incentives, FAMs und mehr auf dem Laufenden halten.',
      forgot:
        'Haben Sie Ihr Passwort vergessen? Klicken Sie auf die Schaltfläche unten und wir senden Ihnen eine E-Mail, um Ihr Passwort zurückzusetzen.',
    },
    forgot: 'Passwort zurücksetzen',
    noAgent: {
      noAgentButton: 'Ich bin kein Berater',
      title: 'Vielen Dank für Ihr Interesse in Kalifornien.',
      messageWeb:
        'Der Inhalt dieser Webseite ist ausschließlich für Reiseveranstalter bestimmt. Um mehr über Kalifornien STAR zu erfahren, besuchen Sie bitte:',
      messageMobile:
        'Einige Inhalte dieser App sind ausschließlich für Reiseveranstalter bestimmt, Sie können jedoch eine Vorschau des Angebots dieser App anzeigen, indem Sie auf "Fortfahren" klicken.',
      continue: 'Fortfahren',
      visitWebsite: 'Webseite besuchen >',
    },
    newUser: 'Neuer Benutzer',
    register: 'Registrieren',
  },
  welcomeScreen: {
    title: 'Willkommen bei der Visit California STAR-Verkaufshilfe',
    helloUser: 'Hallo {name}',
    hello: 'Hallo,',
    fromAgency: 'von {agency}',
    notUser: 'Sind Sie Nicht {name}?',
    introOnline:
      'Schulen Sie sofort online oder laden Sie den Inhalt vorab, sodass er immer offline verfügbar ist!',
    introOffline:
      'Sie haben bereits die neueste Version vorinstalliert. Beginnen Sie zu jeder Zeit und an jedem Ort mit dem Training oder Verkauf!',
    startTraining: 'Fortfahren',
    downloader: {
      preload: 'vorher laden',
      stop: 'stop',
      init: 'Initialisierung ...',
      lastUpdate: 'letztes Update',
    },
  },
  trainingScreens: {
    review: 'Rückblick',
    start: 'Start',
    continue: 'Fortfahren',
    welcome:
      'Willkommen in unserem neu gestalteten Schulungsbereich. Schließen Sie einfach Module ab, um Punkte für Ihr Endziel zu sammeln, ein Gold CA STAR zu werden! Die Leiste rechts zeigt Ihnen genau, wie es Ihnen geht!',
    restart: 'Neustart',
    durationInMinutes: '{number} minuten',
    percentageComplete: '{number}% Komplett',
    unlock:
      'Entsperren Sie dieses Kapitel, indem Sie das Schulungskapitel abschließen',
    unlockSpecialization:
      'Schalte dieses Kapitel frei, indem du die Grundlagen abschließt',
    unlockSubtitle:
      'Entsperren Sie weitere Kapitel, indem Sie Schulungskapitel abschließen.',
    allUnlocked: 'Du hast alle Kapitel freigeschaltet!',
    certificate: 'Zertifikat',
    courseComplete: 'Kurs abgeschlossen!',
    chapterComplete: 'Kapitel abgeschlossen!',
    message: '{count} STAR-Nachricht',
    messagePlural: '{count} STAR-Nachrichten',
    endReached: 'Du bist am Ende angelangt',
    retainEnd:
      'Verwenden Sie die obere Leiste, um in diesem Kapitel zu navigieren, oder drücken Sie die Zurück-Taste, um zur Übersicht zurückzukehren.',
    watchListenRead: 'Sehe, höre und lese mehr',
    trouble:
      'Es sieht so aus, als hätten Sie Probleme. Möchten Sie diese Frage überspringen?',
    confirm: 'Bestätige deine Antwort',
    choose: 'Bitte wähle eine Antwort',
    chapter: 'Kapitel',
    essential: 'Grundlegende Module',
    essentialSub:
      'Schließen Sie diese Module ab, um Ihren Bronze-CA STAR-Status zu verdienen',
    specialization: 'Spezialisierungsmodule',
    specializationSub:
      'Schließen Sie diese Module ab, um Ihren Silver CA STAR-Status zu erreichen',
    status: 'Aktueller Status',
    completed: '{completed} / {total} Komplett',
  },
  nav: {
    home: 'Startseite',
    train: 'Ausbildung',
    retain: 'Behalten',
    directory: 'Verzeichnis',
    promote: 'Fördern',
    sell: 'Verkaufen',
    info: 'Info',
    media: 'Medien',
    favorites: 'Favoriten',
    contact: 'Kontakt',
    reportCard: 'Ergebniskarte',
    accountSettings: 'Account-Einstellungen',
    messages: 'Nachrichten',
    search: 'Suchen',
    showcases: 'Schaukästen',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  contentHeaders: {
    train: 'Schulungsbibliothek',
    retain: 'Behalten',
    subapps: 'Kalifornischer Partner Mini-Training',
    maintrainings: 'Die Stiftung',
    subtrainings: 'Die Erfahrung',
  },
  pageDescriptions: {
    train:
      'Informieren Sie sich, engagieren Sie sich und werden Sie zum Experten.',
    retain:
      'Ihre Anlaufstelle, um Ihr Expertenwissen zu bewahren und Ihre Vertriebsanstrengungen zu unterstützen. Nutzen Sie diesen Bereich, um eine Produktfrage fachmännisch zu beantworten oder sogar als spontane Verkaufspräsentation – jederzeit, überall und von jedem Gerät aus.',
    promote:
      'Medien und Verkaufshilfsmittel für leichten Zugriff und gemeinsame Nutzung',
    sell: 'Leichter Zugriff auf gemeinsames Vertriebsmaterial',
    favorites: 'Dein persönlich bevorzugter Inhalt',
    search: 'Suchen',
    subapps: 'Erfahren Sie mehr von unseren Partnern',
    maintrainings:
      'Schließen Sie diese wichtigen Kapitel ab, um Ihr Diplom zu erhalten!',
    subtrainings:
      'Verdienen Sie sich ein Abzeichen, indem Sie jede der unten aufgeführten speziellen Erfahrungen abschließen.',
  },
  general: {
    showcase: 'Showcases',
    next: 'nächste',
    previous: 'vorig',
    submit: 'Absenden',
    back: 'zurück',
    close: 'schließen',
    page: 'Seite',
    search: 'Suchen',
    logIn: 'Einloggen',
    logOut: 'Ausloggen',
    viewItem: '{type} ansehen',
    imageNotFound: 'Bild nicht gefunden',
    noResultsFor: 'Es wurden keine Ergebnisse gefunden für: {query}',
    noFavorites: 'Du hast noch keine Favoriten.',
    noMessages: 'Du hast noch keine Nachrichten erhalten!',
    resultsFor: 'Ergebnisse für {query}',
    showAll: 'Zeige alles',
    connectionError: 'Verbindungsfehler',
    alreadyExists: 'ist bereits vorhanden',
    pageNotFound: '',
    oops: '',
    overview: 'zurück zur Übersicht',
    complete: 'Kurs abgeschlossen!',
    share: 'Teilen',
    destinations: 'Kalifornischer Partner Mini-Training',
    essentials: 'Das Wesentliche von Kalifornien',
    trainingLibrary: 'Schulungsbibliothek',
    message: '{count} Nachricht',
    messagePlural: '{count} Nachrichten',
    badge: 'Abzeichen',
  },
  itemTypes: {
    image: 'Bild',
    brochure: 'Sammlung',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Sammlung',
  },
  questions: {
    dials: 'Drehen Sie die Drehregler, um die Antwort abzugleichen',
    fitb: 'Fülle die Lücken aus',
    flip: 'Ändern Sie die Nummer entsprechend der Antwort',
    multipleChoice: 'Wählen Sie die richtigen Antwort(en) aus.',
    slider:
      'Ziehen Sie den Balken nach rechts und stoppen Sie bei Ihrer Antwort.',
    map: 'Tippen Sie die Antwort auf der Karte an.',
    dropdown: 'Wähle...',
    true: 'Wahr',
    false: 'Falsch',
  },
  cookies: {
    consent: 'Zustimmen',
    optout: 'Aussteigen',
    settings: 'Datenschutzeinstellungen',
    message:
      'Sie haben uns nichts über Ihre Datenschutzpräferenzen erzählt! Das ist in Ordnung, aber wir möchten Ihnen die beste Erfahrung mit dem Sales Companion bieten.',
    disabled: 'Sie haben anscheinend die Verwendung von Cookies deaktiviert.',
    use: 'Der {appName} erfordert die Verwendung von Cookies, um Ihnen die bestmögliche Erfahrung zu bieten.',
    details: 'Wozu werden Cookies verwendet?',
    enable: 'So aktivieren Sie Ihre Cookies {here}.',
    here: 'hier',
  },
  notLoggedIn: {
    super: 'Du bist nicht angemeldet',
    title: 'Sie müssen angemeldet sein, um diesen Inhalt anzeigen zu können',
    guest: 'Gast',
  },
  demo: {
    message: '',
    consent: 'Begriffen!',
  },
  share: {
    header:
      'Teilen Sie diese Ressource in Ihren bevorzugten sozialen Netzwerken!',
    download: 'download',
  },
  breadCrumbs: {
    page: 'Seite',
  },
  onMobile: {
    header:
      'Anscheinend versuchen Sie, über ein Mobilgerät auf die App {appName} zuzugreifen',
    body: 'Um dieses Programm herunterzuladen, besuchen Sie einfach Ihren App Store und suchen Sie nach {appName} oder klicken Sie auf eine der Schaltflächen unten',
    benefits: {
      header: 'Damit erhalten Sie:',
      1: 'Portabilität',
      2: 'Keine Notwendigkeit für WLAN, trainieren, wann und wo es bequem ist',
      3: 'Verkaufstools und -ressourcen an Ihren Fingerspitzen',
    },
  },
  sharing: {
    twitter: 'Erwägen Sie Ihren nächsten Urlaub in Kalifornien …',
    imageEmailSubject: 'Nur für Sie, von California STAR...',
    imageEmailCopy:
      'Nehmen Sie sich eine Minute Zeit, um die beigefügten Inhalte des California STAR-Urlaubs zu lesen … Viel Spaß!',
    videoEmailSubject:
      'Coole California STAR-Urlaubsideen werden mit Ihnen geteilt!',
    videoEmailCopy:
      'Ich dachte, Sie würden dieses California STAR-Urlaubsvideo genießen.',
    infographicEmailSubject:
      'Teilen Sie etwas über California STAR-Urlaubsideen...',
    infographicEmailCopy:
      'Wir denken, dies würde Sie interessieren, nehmen Sie sich einen Moment Zeit, um den beigefügten Inhalt anzusehen.',
    copyURL: 'Link kopieren',
    copied: 'Kopiert',
  },
  newTrainingFlow: {
    tip: 'Tipp: Sie verdienen Ihren Status, indem Sie die Module innerhalb jeder Stufe abschließen. Haben Sie großartige Träume und erreichen Sie den Gold CA STAR-Status indem Sie alle Module abschließen!',
    essentialModules: 'Grundlegende Module',
    finishBronze:
      'Schließen Sie diese Module ab, um Ihren Bronze-CA STAR-Status zu verdienen',
    specializationModules: 'Spezialisierungsmodule',
    finishSilver:
      'Schließen Sie diese Module ab, um Ihren Silver CA STAR-Status zu erreichen',
    partnerModules: 'Partnermodule',
    finishGold:
      'Schließen Sie diese Module ab, um Ihren Gold CA STAR-Status zu erreichen',
    currentStatus: 'Aktueller Status',
    pointsToLevel: '{pointsToLevel} {points}',
    reachedRanking: 'bis Sie den {rank} Rang erreicht haben!',
    outOf: '{points} XP von',
    pointsToRank: '{pointsToLevel} XP für Rang erforderlich: ({rank})',
    essential: 'Grundlegende Module',
    essentialSub:
      'Schließen Sie diese Module ab, um Ihren Bronze-CA STAR-Status zu verdienen',
    specialization: 'Spezialisierungsmodule',
    specializationSub:
      'Schließen Sie diese Module ab, um Ihren Silver CA STAR-Status zu erreichen',
    completed: '{completed} / {total} Komplett',
  },
  points: {
    completed: '{completed} / {total} Komplett',
  },
  new: {
    achievements: 'Erfolge',
  },
  badgeView: {
    title: 'Ausbildung - Errungenschaften',
    subtitle:
      'Willkommen auf Ihrer Erfolgsseite, wo Sie Ihre Diplome und Spezialisierungsabzeichen einsehen, verfolgen und herunterladen können.',
    badgeDisplayTitle: 'Metallischer Achievement-Status',
    badgeAchievement:
      'Sie haben den Status {rank} erreicht! Klicken Sie auf das Symbol auf der rechten Seite, um Ihren Status zu sehen und zu teilen.',
    bronze: 'Bronze',
    silver: 'Silber',
    gold: 'Gold',
    platinum: 'Platin',
    complete: 'COMPLETE',
    diploma: 'Urkunde',
    chapterBadges: 'Spezialisierungsabzeichen',
    partnerBadges: 'Partner-Abzeichen',
  },
  badgeDisplay: {
    status: 'Status des Ausbildungserfolgs',
  },
  search: {
    pages: 'Seiten',
    resources: 'Ressourcen',
  },
};
